export const CONFIGURATION_PATH = "/configuration";

export const configurationParamLabel: Record<string, string> = {
  GENERAL: "Chung",
  COMMISSION_TEAM_BONUS_RATE: "Tỷ lệ thưởng đội hoa hồng SALE (%)",
};

export const configurationDataTypeLabel: Record<string, string> = {
  STRING: "Chuỗi",
  NUMBER: "Số",
  BOOLEAN: "Đúng/Sai",
};
